import { Prmena } from './defects.dto'

export const SET_CODE_PREFIX = 'SET_'
export const SET_CODE_MAX_LENGTH = 100

export const normalizeSetCode = (value: unknown): string => {
  const normalized = `${value || ''}`.trim().toUpperCase()

  if (!normalized) {
    return SET_CODE_PREFIX
  }

  return normalized.startsWith(SET_CODE_PREFIX) ? normalized : `${SET_CODE_PREFIX}${normalized}`
}

export const isValidSetCode = (value: unknown): boolean => {
  const code = `${value || ''}`.trim()
  const suffix = code.startsWith(SET_CODE_PREFIX) ? code.slice(SET_CODE_PREFIX.length) : ''

  return code.length <= SET_CODE_MAX_LENGTH && !!suffix && !suffix.startsWith('_') && !suffix.startsWith('-')
}

export interface SetDTO {
  id_material?: string
  nazev?: string
  nazevSk?: string
  prcena?: number
  prcenasDPH?: number
  zmeneno?: Date
  obrazky?: string | string[]
  poznweb?: string
  poznwebSk?: string
  rich_popis_pro_web?: string
  prmena?: Prmena
  prcenaSk?: number
  kat1?: string
  kat_id?: string
  prodej_povolen?: number
  web?: number
  zalozeno?: Date
  slevaCz?: number
  slevaSk?: number
}

export interface SetItemDTO {
  id_material?: string
  kod?: string
  nazev?: string
  cena?: number
  cenaSk?: number
  sleva?: number
  slevaSk?: number
  mnozstvi?: number
  hmotnost?: Date
  hmotnostCelkem?: string | string[]
  delka?: string
  sirka?: string
  mj_id?: string
  mena_id?: string
  procento?: string
  sklad?: number
  obrazky?: string | string[]
}

export interface SetFormItemDTO {
  id_material: string
  kod: string
  nazev: string
  mnozstvi: number
  prcena: number
  prcenaSk?: number
  sleva: number
  slevaSk?: number
  sklad?: number
  obrazky?: string[]
}

export interface SetFormDTO {
  id_material: string
  nazev: string
  nazevSk: string
  poznweb: string
  poznwebSk: string
  prcena: number
  prcenaSk: number
  web: number
  prodej_povolen: number
  obrazky: string[]
  kategorie: string[]
  items: SetFormItemDTO[]
}

export interface SetMarketingContentRequestItemDTO {
  id_material: string
  kod?: string
  nazev?: string
  mnozstvi: number
}

export interface SetMarketingContentRequestDTO {
  setCode?: string
  currentName?: string
  items: SetMarketingContentRequestItemDTO[]
}

export interface SetMarketingContentDTO {
  name: string
  nameSk: string
  description: string
  descriptionSk: string
}

export interface SetMarketingTranslationRequestDTO {
  name: string
  description: string
}

export interface SetMarketingTranslationDTO {
  nameSk: string
  descriptionSk: string
}
